//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';

export default {
	components: {
		draggable: draggable
	},
	props: {
		website: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		galleryName: {
			type: String,
			default: 'main'
		},
		showMediaGallery: false,
		allowUpload: {
			type: Boolean,
			default: true
		},
		removeImage: {
			type: Boolean,
			default: true
		},
		image: null
	},
	data: function data() {
		return {
			open: false,
			title: '',
			selectedItem: {},
			showOverlay: false,
			images: [{
				"id": "0",
				"author": "Alejandro Escamilla",
				"width": 5616,
				"height": 3744,
				"url": "https://unsplash.com/photos/yC-Yzbqy7PY",
				"download_url": "https://picsum.photos/id/0/5616/3744"
			}, {
				"id": "1",
				"author": "Alejandro Escamilla",
				"width": 5616,
				"height": 3744,
				"url": "https://unsplash.com/photos/LNRyGwIJr5c",
				"download_url": "https://picsum.photos/id/1/5616/3744"
			}]
		};
	},

	methods: {
		closeSlideout: function closeSlideout() {
			this.open = false;
			Event.$emit('close-media-slideout');
			Event.$emit('img-uploader-hide-media-gallery');
		},
		viewImgDetails: function viewImgDetails(img, idx) {
			Event.$emit('open-media-slideout');

			this.selectedItem = img;
			this.selectedItem.index = idx;

			this.showOverlay = true;
		},
		updateOrder: function updateOrder(evt) {
			var _this = this;

			if (this.images.length) {
				axios.post('/prototype/website/' + this.website.id + '/gallery/' + this.images[0].pivot.website_gallery_id + '/gallery-order', { photos: this.images }).then(function () {
					_this.$snotify.success('Photo order was updated');
				});
			}
		},
		deleteImage: function deleteImage(img) {
			var _this2 = this;

			Event.$emit('close-media-slideout');
			// /website/{id}/photo/{photoId}/delete'
			axios.post('/prototype/website/' + this.website.id + '/photo/' + img.id + '/delete').then(function (response) {
				if (response.data.error) {
					_this2.$snotify.error('Error removing image: ' + response.data.error);
				} else {
					_this2.$snotify.success('Image removed');
					_this2.images.splice(img.index, 1);
					_this2.showOverlay = false;
					Event.$emit('refresh-property-website', _this2.website.property_id);
				}
			});
		},
		selectImage: function selectImage(img) {
			alert('You selected this image:' + img);
			Event.$emit('refresh-property-website', this.website.property_id);
		},
		reloadSlideout: function reloadSlideout() {
			var _this3 = this;

			var $el = this;
			console.log('reloadSlideout');
			if (this.galleryName && this.showMediaGallery) {
				console.log('show gallery = ' + this.galleryName);
				$el.open = true;
				axios.get('/prototype/website/' + $el.website.id + '/gallery/' + $el.galleryName).then(function (response) {
					if (response.data.error) {
						_this3.$snotify.error('Error getting gallery images: ' + response.data.error);
					} else {
						_this3.$snotify.success('Gallery images loaded');
						console.log('Loaded Gallery images');
						console.log(response.data);
						$el.title = response.data.title;
						$el.images = response.data.photos;
					}
				});
			}
		}
	},
	mounted: function mounted() {
		var _this4 = this;

		var $el = this;

		Event.$on('open-media-folder', function (folder) {
			console.log('Event Fired: open-media-folder');
			$el.open = true;
			axios.get('/prototype/website/' + $el.website.id + '/gallery/' + folder).then(function (response) {
				if (response.data.error) {
					_this4.$snotify.error('Error getting gallery images: ' + response.data.error);
				} else {
					_this4.$snotify.success('Gallery images loaded');
					console.log('Gallery images');
					console.log(response.data);
					$el.title = response.data.title;
					$el.images = response.data.photos;
				}
			});
		});

		Event.$on('hide-media-overlay', function () {
			$el.showOverlay = false;
		});
	},

	watch: {
		showMediaGallery: function showMediaGallery(newVal, oldVal) {
			var $el = this;
			console.log('showMediaGallery changed');
			this.reloadSlideout();
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/media/MediaSlideOut.vue
// module id = 3e88
// module chunks = 0 1